import type {
  FormulaToken,
  FormulaVariable,
  ResultViewKey,
  VariableToken,
} from "./formulaBuilder.types";

export const RESULT_VIEW_KEYS: ResultViewKey[] = [
  "value_vs_target",
  "trend",
  "breakdown",
  "components",
];

export const tokenLabel = (token: FormulaToken): string => {
  if (token.type === "variable") return token.label;
  if (token.type === "operator") return token.op;
  if (token.type === "literal") return String(token.value);
  if (token.type === "function") {
    const argLabels = token.args.map((a) => a.label).join(", ");
    return `${token.name}(${argLabels})`;
  }
  return "";
};

export const buildExpression = (tokens: FormulaToken[]): string => {
  return tokens.map(tokenLabel).join(" ");
};

export const variableToToken = (variable: FormulaVariable): VariableToken => {
  return {
    type: "variable",
    variable_id: variable.id,
    source_type: variable.source_type,
    source_id: variable.source_id,
    label: variable.label,
    aggregation: variable.default_aggregation ?? "mean",
    metadata: variable.metadata ?? {},
  };
};

export const GRAIN_LABELS: Record<string, string> = {
  respondent: "Per respondent",
  site_group: "Per site / group",
  indicator: "Per indicator",
  project: "Per project",
};

export const OUTPUT_TYPE_LABELS: Record<string, string> = {
  score: "Score",
  percent: "Percent (%)",
  index: "Index (0-100)",
  count: "Count",
  ratio: "Ratio",
};

export const STATUS_LABELS: Record<string, string> = {
  on_track: "On target",
  at_risk: "At risk",
  off_track: "Below target",
};

export const TRAFFIC_LIGHT_COLORS: Record<
  string,
  { color: string; bg: string }
> = {
  green: { color: "#16a34a", bg: "#dcfce7" },
  yellow: { color: "#d97706", bg: "#fef3c7" },
  red: { color: "#dc2626", bg: "#fee2e2" },
};
